import { useAuth } from "@clerk/clerk-react";
import BalanceChart from "Components/Charts/BalanceChart/BalanceChart";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "Components/ui/accordion";
import { Button } from "Components/ui/button";
import { Separator } from "Components/ui/separator";
import { Skeleton } from "Components/ui/skeleton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getChallengeInfo } from "../../../../Redux/ChallengeMain/ChallengeMainActions";
import mt5Icon from "../../../../Assets/Images/mt5icon.svg";
import tradeLockerIcon from "../../../../Assets/Images/tradelockerIcon.svg";
import { useTheme } from "hooks/ThemeContext";
import TradeLockerBlack from "Assets/Images/TradeLockerBlack.svg";

function FirstSec() {
  const { theme } = useTheme();
  const [selectedGraph, setSelectedGraph] = useState();

  const { challenges, getChallengesLoading } = useSelector(
    (state) => state.challengeMainReducer
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getToken } = useAuth();

  useEffect(() => {
    if (selectedGraph) {
      dispatch(getChallengeInfo(getToken, selectedGraph));
    }
  }, [selectedGraph]);

  useEffect(() => {
    if (challenges) {
      setSelectedGraph(challenges[0]?.challengeId);
    }
  }, [challenges]);

  return (
    <div className="flex-1 flex flex-col flex-grow-[2] bg-background border-border-darkNew border-2 rounded-lg p-4 overflow-auto max-h-[30rem]">
      <div className="flex items-center justify-between gap-4">
        <div className="text-lg text-baseColor">Challenges</div>
        <Button
          className="text-sm px-4 py-0"
          onClick={() => {
            navigate("/landing");
          }}
        >
          New Challenge
        </Button>
      </div>
      <Separator className="bg-border-darkNew my-6" />

      <Accordion
        type="single"
        collapsible={false}
        className={`w-full h-full overflow-auto hideScrollBar`}
        onValueChange={(value) => setSelectedGraph(value)}
        value={selectedGraph}
      >
        {getChallengesLoading ? (
          <div className="w-full space-y-2">
            {/* Header section */}
            <div className="flex items-center justify-between">
              <Skeleton className="h-6 w-full max-w-[180px]" />
              <Skeleton className="h-6 w-full max-w-[60px]" />
            </div>

            {/* Chart section */}
            <div className="py-4">
              <Skeleton className="h-[200px] w-full" />
            </div>

            {/* Balance section */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-full max-w-[100px]" />{" "}
              {/* "Your Balance" text */}
              <div className="flex items-baseline gap-2">
                <Skeleton className="h-8 w-full max-w-[140px]" /> {/* Amount */}
                <Skeleton className="h-4 w-full max-w-[40px]" />{" "}
                {/* Currency */}
              </div>
            </div>
          </div>
        ) : challenges?.length > 0 ? (
          challenges?.map((item, index) => {
            return (
              <AccordionItem
                key={index}
                value={item?.challengeId}
                className={`bg-black-dark rounded-lg p-4  ${
                  selectedGraph !== item?.challengeId && "py-[0.4rem]"
                }`}
                onClick={() => {
                  selectedGraph == item?.challengeId &&
                    navigate("/challenge/" + item?.challengeId + "/overview");
                }}
              >
                <AccordionTrigger className="flex flex-row gap-4 items-center">
                  <div
                    className={`font-N_Thin text-sm flex flex-row gap-2 ${
                      selectedGraph !== item?.challengeId && "w-full max-w-max"
                    }`}
                  >
                    {item?.platform.toLowerCase() === "platform 5" ? (
                      <img src={mt5Icon} alt="mt5Icon" />
                    ) : (
                      <img
                        src={
                          theme === "light" ? TradeLockerBlack : tradeLockerIcon
                        }
                        alt="tradeLockerIcon"
                      />
                    )}
                    <div className="text-baseColor">
                      CH#ID {item?.login}{" "}
                      <span className="font-N_Thin text-sm text-white-opacity">
                        (Phase {item?.stagePhase})
                      </span>
                    </div>
                  </div>
                  {selectedGraph !== item?.challengeId && (
                    <span
                      className={`text-sm ${
                        item?.status === "ACTIVE"
                          ? "text-green"
                          : item?.status === "PASSED"
                          ? "text-primary"
                          : "text-red"
                      } font-N_Medium`}
                    >
                      {item?.status?.toLowerCase().charAt(0).toUpperCase() +
                        item?.status?.toLowerCase().slice(1)}
                    </span>
                  )}
                  {selectedGraph === item?.challengeId ? (
                    <div
                      className={`text-sm ${
                        item?.status === "ACTIVE"
                          ? "text-green"
                          : item?.status === "PASSED"
                          ? "text-blue"
                          : "text-red"
                      } font-N_Medium`}
                    >
                      {item?.status?.toLowerCase().charAt(0).toUpperCase() +
                        item?.status?.toLowerCase().slice(1)}
                    </div>
                  ) : (
                    <div className="w-full flex flex-row gap-4 items-center">
                      <BalanceChart
                        height={40}
                        variant={"secondary"}
                        chartData={item?.equities.map((data) => ({
                          time: new Date(data?.time)?.getTime() / 1000,
                          value: data?.value,
                        }))}
                      />
                      <Button
                        className="py-0 px-6 bg-background-secondaryOpacity text-primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/challenge/${item?.challengeId}/overview`);
                        }}
                      >
                        View
                      </Button>
                    </div>
                  )}
                </AccordionTrigger>
                <AccordionContent>
                  <BalanceChart
                    title={`CH#ID 123`}
                    subTitle={`(Phase 1)`}
                    status={"ACTIVE"}
                    info={"Your Balance"}
                    price={item?.balance}
                    currency={item?.currency}
                    chartData={item?.equities.map((data) => ({
                      time: new Date(data?.time)?.getTime() / 1000,
                      value: data?.value,
                    }))}
                  />
                </AccordionContent>
              </AccordionItem>
            );
          })
        ) : (
          <div className="text-base text-white-opacity h-full flex flex-col gap-0 items-center justify-center cursor-pointer ">
            <div className="font-N_Medium text-2xl ">No Challenges yet!</div>
            <div className="font-N_Light text-base w-full max-w-[18rem]  text-center">
              Create challenges to see updates here.
            </div>
          </div>
        )}
      </Accordion>
    </div>
  );
}

export default FirstSec;
